export default function padLeft(input: string | number, length: number, symbol: string): string {
    const inputAsString = String(input);

    let output = "";

    const quantity = length - inputAsString.length;
    for (let x = 0; x < quantity; x++) {
        output += symbol;
    }

    return output + inputAsString;
}



// WEBPACK FOOTER //
// ./src/utils/padLeft.ts